export const OperatingLayout: React.FC<{
  children: React.ReactNode;
  pageTitle?: string;
  pageHeader?: string;
}> = ({ children, pageHeader }) => {
  return (
    // <BaseLayout pageTitle={pageTitle || "Operating Platform"}>
    <div className="flex flex-col gap-4">
      <h3>{pageHeader || ""}</h3>
      {children}
    </div>
    // </BaseLayout>
  );
};
